module.exports = __webpack_public_path__ + "media/src/images/mails/badge_grade_a-9169c5fb0a1065d142ad7a001803f53d.png";